import { ClassbookSidebarItem, SidebarTreeItem } from './ClassbookSidebar';

export const classbookSidebarItemToTreeItemProps = (
  item: ClassbookSidebarItem,
): SidebarTreeItem => {
  return {
    key: `classbook-sidebar-item-${item.id}`,
    id: item.id,
    title: item.name,
    'data-cy': 'classbookSidebarItem',
  };
};
